import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {IconButton, Typography} from '@mui/material';
import Box from '@mui/material/Box';
import {grey} from '@mui/material/colors';
import Grid from '@mui/material/Grid';

import useProfile from '../../../../../hooks/providers/useProfile';
import {flowShape} from '../../../../../proptypes-shapes';
import HeaderOnboardingSingleFlowProgressBar from '../HeaderOnboardingSingleFlowProgressBar/HeaderOnboardingSingleFlowProgressBar';
import HeaderOnboardingSingleFlowStepsList from '../HeaderOnboardingSingleFlowStepsList/HeaderOnboardingSingleFlowStepsList';

const HeaderOnboardingSingleFlow = ({flow}) => {
  const {isFlowCompleted, expandedOnboardingMenuItem, setExpandedOnboardingMenuItem} = useProfile();

  const flowCompleted = isFlowCompleted(flow);
  const isExpanded = expandedOnboardingMenuItem === flow.id;
  const textColor = flowCompleted ? 'text.disabled' : 'text.primary';

  const toggleExpanded = () => {
    setExpandedOnboardingMenuItem(currentExpandedOnboardingMenuItem => (currentExpandedOnboardingMenuItem === flow.id ? null : flow.id));
  };

  const getIconButton = () => {
    return (
      <IconButton aria-label="close" color="inherit" size="small">
        {isExpanded ? <ExpandMoreIcon /> : <ExpandLessIcon />}
      </IconButton>
    );
  };

  return (
    <Box
      sx={{
        cursor: 'pointer',
        borderBottom: `1px solid ${grey[300]}`
      }}
      py={1}
      pl={2}
      pr={1}
    >
      <Grid onClick={toggleExpanded} container alignItems="center" justifyContent="space-between" flexWrap="nowrap">
        <Box flex={1}>
          <Typography color={textColor} fontSize={16}>
            {flow.title}
          </Typography>
          <HeaderOnboardingSingleFlowProgressBar flow={flow} />
        </Box>
        {getIconButton()}
      </Grid>
      {isExpanded ? <HeaderOnboardingSingleFlowStepsList flow={flow} /> : null}
    </Box>
  );
};

HeaderOnboardingSingleFlow.propTypes = {
  flow: flowShape.isRequired
};

export default HeaderOnboardingSingleFlow;
